import script from "./AvatarUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./AvatarUpload.vue?vue&type=script&setup=true&lang=ts"

import "./AvatarUpload.vue?vue&type=style&index=0&id=7e422d92&lang=css"

const __exports__ = script;

export default __exports__